export class ShowLoadingSpinner {
  static readonly type = '[LOADINGSPINNER] Show';
}

export class HideLoadingSpinner {
  static readonly type = '[LOADINGSPINNER] Hide';
}
